/* global femcare */

femcare.general.anchorLink = {
    init: function() {
        var that = this;

        $('a[href*=\\#]:not(.tab-link)').on('click', function(event) {
            
            var target = event.currentTarget;

            if(!$(target).hasClass('cart-checkout__button') && !$(target).hasClass('cart-notification-checkout__button')){
            // Only scroll to anchor/references if it is on the same page.
                if (
                    $(this.hash).length &&
                    this.pathname === window.location.pathname &&
                    this.protocol === window.location.protocol &&
                    this.host === window.location.host
                ) {
                    event.preventDefault();
                    var sectionYOffset = $(this.hash).offset().top;
                    var targetY = sectionYOffset + 1;

                    // If always visible (eg. not hidden on scroll) then factor in the navbar height.
                    var addNavbarOffset = femcare.shared.util.isRichNavbarActive();

                    if (addNavbarOffset) {
                        var navbarStaticHeight = 90;
                        targetY -= navbarStaticHeight;
                    }

                    that.animateSection(targetY);
                }
            }
        });
    },

    animateSection: function(offset) {
        $('html, body').animate(
            {
                scrollTop: offset
            },
            1000
        );
    }
};
